import { render } from "./CustomDoughnutChart.vue?vue&type=template&id=83d44570&scoped=true"
import script from "./CustomDoughnutChart.vue?vue&type=script&lang=js"
export * from "./CustomDoughnutChart.vue?vue&type=script&lang=js"

import "./CustomDoughnutChart.vue?vue&type=style&index=0&id=83d44570&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83d44570"]])

export default __exports__